module.exports = __webpack_public_path__ + "img/customerTitle.de4af4af.png";